import React from 'react';

/* Added the following code for POW-872.Harsha using AI Agent. July 9, 2026. Code Start */
const CandidatePortalConfig = {
	settings: {
		layout: {
			config: {
				navbar: { display: false },
				toolbar: { display: false },
				footer: { display: false },
				leftSidePanel: { display: false },
				rightSidePanel: { display: false }
			}
		}
	},
	routes: [
		{
			path: '/candidate/jobs/:jobId/view',
			component: React.lazy(() => import('./jobs/CandidateJobView'))
		},
		{
			path: '/candidate/jobs/:jobId/apply',
			component: React.lazy(() => import('./apply/CandidateApply'))
		},
		{
			path: '/candidate/jobs/:jobId/review',
			component: React.lazy(() => import('./apply/CandidateApplyReview'))
		},
		{
			path: '/candidate/jobs',
			exact: true,
			component: React.lazy(() => import('./jobs/CandidateJobs'))
		}
	]
};

export default CandidatePortalConfig;
/* Code end. Harsha using AI Agent. July 9, 2026 */
